var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content mangoUsers" },
    [
      _vm.modalData
        ? _c(
            "EmptyModal",
            {
              ref: "emptyModal",
              attrs: {
                onModalClose: _vm.onModalClose,
                onModalAccept: _vm.updatePhoneSettings,
                modalData: _vm.modalData,
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c("div", [
                    _c("div", { staticClass: "flex" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Выбор менеджера"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedRecord.managerId,
                                expression: "selectedRecord.managerId",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.selectedRecord,
                                  "managerId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          _vm._l(_vm.managers, function (manager) {
                            return _c(
                              "option",
                              { domProps: { value: manager.id } },
                              [_vm._v(_vm._s(manager.name))]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Выбор проекта"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedRecord.projectId,
                                expression: "selectedRecord.projectId",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.selectedRecord,
                                  "projectId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _vm._l(_vm.$AllProjects, function (project) {
                              return _c(
                                "option",
                                { domProps: { value: project.id } },
                                [_vm._v(_vm._s(project.name))]
                              )
                            }),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "0" } }, [
                              _vm._v("Все проекты"),
                            ]),
                          ],
                          2
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("table", { staticClass: "table table-sm" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th"),
                            _vm._v(" "),
                            _c("th", [_vm._v("ID линии")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Номер линии")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Описание линии")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Название для менеджера")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Город")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(
                            _vm.selectedRecord.activatedLines,
                            function (line, index) {
                              return _c("tr", { key: index }, [
                                _c("td", [_vm._v(_vm._s(index + 1))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(line.line_id))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(line.number))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(line.schema_name))]),
                                _vm._v(" "),
                                _c("td", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: line.phone_title,
                                        expression: "line.phone_title",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    domProps: { value: line.phone_title },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          line,
                                          "phone_title",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: line.city_id,
                                          expression: "line.city_id",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            line,
                                            "city_id",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "0" } }, [
                                        _vm._v("Не использовать"),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.$AllCities,
                                        function (city, ind) {
                                          return _c(
                                            "option",
                                            {
                                              key: ind,
                                              domProps: { value: city.id },
                                            },
                                            [_vm._v(_vm._s(city.name))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                              ])
                            }
                          ),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("pulse-loader", {
              staticClass: "text-center",
              attrs: { loading: _vm.loading, color: _vm.loadingColor },
            }),
            _vm._v(" "),
            !_vm.loading
              ? _c("table", { staticClass: "table table-sm table-hover" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "thead",
                    [
                      _vm._l(_vm.mangoAccounts, function (acc) {
                        return [
                          _c("tr", { staticClass: "account_line" }, [
                            _c("td", { attrs: { colspan: "10" } }, [
                              _vm._v(
                                "\n                (" +
                                  _vm._s(acc.id) +
                                  ") Аккаунт:\n                "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(acc.login) +
                                    " (АТС:" +
                                    _vm._s(acc.ats_num) +
                                    ")\n                  " +
                                    _vm._s(acc.project_name)
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.records[acc.id].error
                            ? [
                                _c("tr", [
                                  _c("td", { attrs: { colspan: "10" } }, [
                                    _vm._v(_vm._s(_vm.records[acc.id].error)),
                                  ]),
                                ]),
                              ]
                            : [
                                _vm._l(
                                  _vm.records[acc.id].users,
                                  function (record, index) {
                                    return _c("tr", [
                                      _c("td", [
                                        _vm._v(_vm._s(record.general.user_id)),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(record.general.name)),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex justify-content-between",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "margin_auto line_id",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    record.telephony.extension
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.managersPhones[acc.id] &&
                                            _vm.managersPhones[acc.id][
                                              record.telephony.extension
                                            ]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "margin_auto p-l-5",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.managersPhones[
                                                          acc.id
                                                        ][
                                                          record.telephony
                                                            .extension
                                                        ].user.name
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-xs btn-info",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openPhoneSettings(
                                                      acc,
                                                      record
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-edit",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.appointedManager(record))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(record.telephony.outgoingline)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        _vm._l(
                                          record.telephony.numbers,
                                          function (number) {
                                            return _c("div", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(number.number) +
                                                  "\n                  "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        _vm._l(
                                          record.groups,
                                          function (group, ind) {
                                            return _c("span", [
                                              _vm._v(
                                                _vm._s(ind !== 0 ? ", " : "") +
                                                  _vm._s(group)
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  }
                                ),
                                _vm._v(" "),
                                _c("tr", { staticClass: "account_line" }, [
                                  _c("td", { attrs: { colspan: "10" } }, [
                                    _vm._v("Подключенные линии:"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.lines[acc.id].lines,
                                  function (line, ind) {
                                    return _c("tr", [
                                      _c("td", [_vm._v(_vm._s(line.line_id))]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(line.schema_name)),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { attrs: { colspan: "2" } }, [
                                        _vm._v(_vm._s(line.number)),
                                      ]),
                                    ])
                                  }
                                ),
                              ],
                          _vm._v(" "),
                          _vm.groups[acc.id].groups &&
                          _vm.groups[acc.id].groups.length
                            ? [
                                _c("tr", { staticClass: "account_line" }, [
                                  _c("td", { attrs: { colspan: "10" } }, [
                                    _vm._v("Группы:"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.groups[acc.id].groups,
                                  function (group, ind) {
                                    return _c("tr", [
                                      _c("td", [_vm._v(_vm._s(ind + 1))]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(group.name))]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(group.id))]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(group.line_id))]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        _vm._l(
                                          group.operators,
                                          function (operator) {
                                            return _c("div", [
                                              _vm._v(
                                                "\n                    id: " +
                                                  _vm._s(operator.id) +
                                                  " - " +
                                                  _vm._s(operator.name) +
                                                  " (очередь:\n                    " +
                                                  _vm._s(operator.order) +
                                                  ")\n                  "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  }
                                ),
                              ]
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("SIP Пользователи Mango")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Название")]),
        _vm._v(" "),
        _c("th", [_vm._v("Внутренний")]),
        _vm._v(" "),
        _c("th", [_vm._v("Менеджер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Исходящая линия")]),
        _vm._v(" "),
        _c("th", [_vm._v("Прикрепленные SIP")]),
        _vm._v(" "),
        _c("th", [_vm._v("Входит в гурппы")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }